import { useLoginInfo } from '@/components/LoginInfo/provider';
import { AgentApplicantTargetOfficeMember } from '@/features/invoice_reports/components/Search/components/AgentApplicantTargetOfficeMember';
import { useTranslation } from '@/i18n';
import { Tooltip } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import { Control } from 'react-hook-form';
import type { PaymentRequestImportForm } from '../../types';
import styles from './ApplicantAndProxyApplicantSection.module.scss';

const cx = classNames.bind(styles);

export type ApplicantAndProxyApplicantSectionProps = {
  /** Form control for the applicant (target_office_member_id) field. */
  control: Control<PaymentRequestImportForm>;
  /** Field name for the applicant single select. */
  name: keyof PaymentRequestImportForm & string;
  /** Optional input id for accessibility. */
  inputId?: string;
};

export const ApplicantAndProxyApplicantSection: FC<ApplicantAndProxyApplicantSectionProps> =
  memo(({ control, name, inputId }) => {
    const { t } = useTranslation();
    const { currentOfficeMember } = useLoginInfo();
    const currentUserName = currentOfficeMember?.userName ?? '';

    const selectProps = useMemo(
      () => ({
        mode: 'single',
        placeholder: '',
        inputPlaceholder: t('office_member_input_placeholder'),
      }),
      [t]
    );

    return (
      <div className={cx('section')}>
        <div className={cx('field')}>
          <span className={cx('fieldLabel')}>
            {t('applicant_office_member')}
          </span>
          <div className={cx('fieldControl')}>
            <AgentApplicantTargetOfficeMember
              control={control}
              name={name}
              inputId={inputId ?? `import-drawer-${name}`}
              selectProps={selectProps}
              display_all_roles={false}
            />
          </div>
        </div>
        <div className={cx('field')}>
          <span className={cx('fieldLabel')}>
            {t('agent_applicant_office_member')}
          </span>
          <Tooltip title={currentUserName} placement='top'>
            <div className={cx('fieldControl', 'selectedList')}>
              {currentUserName}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  });

ApplicantAndProxyApplicantSection.displayName =
  'ApplicantAndProxyApplicantSection';
